// @flow

import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

export type ScreenSize = 'small' | 'medium' | 'large' | 'xlarge';

/**
 * Hook to query viewport "size"
 */
export default function useScreenSize(): ScreenSize {
  const { size } = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'medium' },
    [Screen.queries.tablet]: { size: 'large' },
    [Screen.queries.desktop]: { size: 'xlarge' },
  });

  return size;
}
